/* eslint-disable */
/**
 * [版本比较函数]
 * @param  {[String]} v1              [第一个版本号]
 * @param  {[String]} operator        [比较运算符]
 * @param  {[String]} v2              [第二个版本号]
 * @param  {String} [separator='.'] [版本分割符，默认'.']
 * @return {[Boolean]}                 [比较结果]
 * @example versionCompare('7.5.46','>','7.5.5') => false
 * @example versionCompare('7,5,4','<=','7,5,5',',') => true
 */
export default function versionCompare(v1, operator, v2, separator = '.') {
    let len;
    v1 = v1.split(separator);
    v2 = v2.split(separator);
    len = Math.max(v1.length, v2.length);
    for (let i = 0; i < len; i++) {
        if (v2[i] === v1[i]) {
            continue;
        }
        switch (operator) {
            case '>':
                return +v1[i] > +v2[i];
            case '>=':
                return +v1[i] >= +v2[i];
            case '<':
                return +v1[i] < +v2[i];
            case '<=':
                return +v1[i] <= +v2[i];
        }
    }
    if (operator.indexOf('=') !== -1) {
        return true;
    }
    return false;
}
